import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import "css/EditSolarForm.css";
import Container from "react-bootstrap/Container";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaEyeSlash, FaEye } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import InputGroup from "react-bootstrap/InputGroup";
import apiURL from "apiURL/apiURL";
import apiStatusCode from "constants/apiStatusCode";
import axios from "axios";
import defaultString from "constants/defaultString.json";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AlertDialog from "components/AlertDialog/AlertDialog";
import { useAddAgentValidator } from "hooks/useAddAgentValidator";
import { AuthContext } from "context/AuthContext";
import { resetToken } from "apiURL";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { Close } from "@mui/icons-material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddAgent = (props) => {
  const { t } = useTranslation();

  const [isEdit, setIsEdit] = useState(false);
  const [status, setStatus] = useState(false);
  const [passport, setPassport] = useState("");
  const [code, setCode] = useState("");
  const [dob, setDob] = useState("");
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isRevealCPwd, setIsRevealCPwd] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [open, setOpen] = useState(false);
  const [mainImage, setMainImage] = useState({ id: 0, logo: null });
  const [documents, setDocuments] = useState([]);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [attachmentId, setAttachmentId] = useState("");
  const [isChangeMainImage, setIsChangeMainImage] = useState(false);
  const [indexToBeDelete, setIndexToBeDelete] = useState("");
  const [attachType, setAttachType] = useState("");
  const [logoImageError, setLogoImageError] = useState(false);
  const [isDisabledSaveBtn, setIsDisabledSaveBtn] = useState(false);
  const [isDisabledDeleteBtn, setIsDisabledDeleteBtn] = useState(false);
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [openModal, setOpenModal] = React.useState(false);
  const handleClose = () => setOpenModal(false);
  const [severity, setSeverity] = useState("error");
  const [reload, setReload] = useState(false);

  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    email: "",
    fiscalCode: "",
    discountReward: "",
  });

  const { errors, validateForm, onBlurField } = useAddAgentValidator(form);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "65%",
    maxHeight: "85%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "16px",
    overflowY: "scroll",
  };

  const onUpdateField = (e) => {
    const field = e.target.name;
    const nextFormState = {
      ...form,
      [field]: e.target.value,
    };
    setForm(nextFormState);

    if (errors[field].dirty)
      validateForm({
        form: nextFormState,
        errors,
        field,
      });
  };
  // const [error, setError] = useState({
  //     password: '',
  //     confirmPassword: '',
  //     name: '',
  //     email: ''
  // })

  // const onInputChange = e => {
  //     const { name, value } = e.target;
  //     setInput(prev => ({
  //         ...prev,
  //         [name]: value
  //     }));
  //     validateInput(e);
  // }

  // const validateInput = e => {
  //     let { name, value } = e.target;
  //     console.log('name:value', name, value)
  //     setError(prev => {
  //         const stateObj = { ...prev, [name]: "" };

  //         switch (name) {
  //             case "name":
  //                 if (!value) {
  //                     stateObj[name] = "First Name is required!";
  //                 }
  //                 break;

  //             case "email":
  //                 if (!value) {
  //                     stateObj[name] = "Email is required!";
  //                 } else if (!new RegExp(/\S+@\S+\.\S+/).test(value)) {
  //                     stateObj[name] = "Incorrect email format";
  //                 }
  //                 break;

  //             case "password":
  //                 if (!value) {
  //                     stateObj[name] = "Password is required!";
  //                 } else if (input.confirmPassword && value !== input.confirmPassword) {
  //                     stateObj["confirmPassword"] = "Password and Confirm Password does not match.";
  //                 } else {
  //                     stateObj["confirmPassword"] = input.confirmPassword ? "" : error.confirmPassword;
  //                 }
  //                 break;

  //             case "confirmPassword":
  //                 if (!value) {
  //                     stateObj[name] = "Confirm Password is required!";
  //                 } else if (input.password && value !== input.password) {
  //                     stateObj[name] = "Password and Confirm Password does not match.";
  //                 }
  //                 break;

  //             default:
  //                 break;
  //         }

  //         return stateObj;
  //     });
  // }

  console.log("stateObj", props.stateObj);

  useEffect(() => {
    if (props.stateObj) {
      setIsEdit(true);

      setForm({
        firstName: props.stateObj.firstName,
        email: props.stateObj.email,
        lastName: props.stateObj.lastName,
        fiscalCode: props.stateObj.fiscalCode,
        discountReward: props.stateObj.discountReward,
      });
      let prodStatus = props.stateObj.status === "Active" ? true : false;
      setStatus(prodStatus);
      setPassport(props.stateObj.passportId);
      setDob(props.stateObj.dob);
      setCode(props.stateObj.code);

      if (props.stateObj.mainImage.logo !== null) {
        setMainImage(props.stateObj.mainImage);
      }

      let uploadedDocArray = [];
      if (props.stateObj.documents.length > 0) {
        for (let i = 0; i < props.stateObj.documents.length; i++) {
          uploadedDocArray.push(props.stateObj.documents[i]);
        }
        setDocuments(uploadedDocArray);
      }
    }
  }, [props]);

  useEffect(() => {
    if (!props.isEdit) {
      setForm({
        password: "",
        confirmPassword: "",
        firstName: "",
        lastName: "",
        email: "",
        fiscalCode: "",
        discountReward: "",
      });
      setStatus("");
      setPassport("");
      setDob("");
      setCode("");
      setMainImage("");
      setDocuments("");
    }
    if (props.handleClose) {
      setLogoImageError(false);
      validateForm({
        form: form,
        errors: {
          password: "",
          confirmPassword: "",
          firstName: "",
          lastName: "",
          email: "",
          fiscalCode: "",
          discountReward: "",
        },
      });
    }
  }, [props.handleClose, props.isEdit]);

  const handleMainPicture = (event) => {
    const isLt2M = event.target.files[0].size / 1024 / 1024 < 2;
    if (!isLt2M) {
      setSeverity("error");
      setOpen(true);
      setErrorMsg("Image must smaller than 2MB!");
      return;
    }
    setMainImage({ id: 0, logo: event.target.files[0] });
    setLogoImageError(false);
    setIsChangeMainImage(true);
  };

  const handleDocuments = (event) => {
    let attachmentObj = [];
    attachmentObj.push(event.target.files);

    for (let i = 0; i < attachmentObj[0].length; i++) {
      let docuObj = {};
      docuObj.id = 0;
      docuObj.document = attachmentObj[0][i];

      setDocuments((x) => [...x, docuObj]);
    }
  };

  const handleDeleteAlertClose = () => {
    setOpenDeleteAlert(false);
    setAttachmentId("");
    setAttachType("");
    setIndexToBeDelete("");
  };

  const confirmDeleteItem = async () => {
    console.log("attachmentId:: ", attachmentId);
    setOpenDeleteAlert(false);

    if (attachType == "mainImage") {
      if (attachmentId !== 0) {
        await fnDeleteAttachment(attachmentId);
      } else {
        setMainImage({ id: 0, logo: null });
        setLogoImageError(true);
      }
      let inputId = document.getElementById("formFile1");
      inputId.value = null;
    } else if (attachType === "document") {
      console.log("indexToBeDelete: ", indexToBeDelete);
      if (attachmentId !== 0) {
        await fnDeleteAttachment(attachmentId);
      } else {
        const filteredArr = documents.filter(
          (item, index) => index !== indexToBeDelete
        );
        setDocuments(filteredArr);
      }
      // let inputId = document.getElementById('otherImages');
      // inputId.value = null;
    } else if (attachType === "product") {
      if (attachmentId !== 0) {
        await fnDeleteProduct(attachmentId);
      }
    }
  };

  const deleteItem = (itemId, index, attachmentType) => {
    // const s = attachments.filter((item, index) => index !== e);
    // setAttachments(s);
    // console.log(attachments)
    // console.log(s);
    setOpenDeleteAlert(true);
    setAttachmentId(itemId);
    setIndexToBeDelete(index);
    setAttachType(attachmentType);
  };

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const fnAddUser = async (e) => {
    e.preventDefault();
    // const token = JSON.parse(localStorage.getItem(defaultString.jsonWebToken))
    if (!mainImage.logo) {
      setLogoImageError(true);
      setSeverity("error");
      setOpen(true);
      setErrorMsg(defaultString.validData);
    }
    const { isValid } = validateForm({ form, errors, forceTouchErrors: true });
    if (!isValid) {
      setSeverity("error");
      setOpen(true);
      setErrorMsg(defaultString.validData);
      return;
    }
    console.log(mainImage);

    if (documents.length > 5) {
      setSeverity("error");
      setOpen(true);
      setErrorMsg(defaultString.maxDocumentLimitMsg);
      return;
    }

    if (
      form.email &&
      form.password &&
      form.firstName &&
      form.lastName &&
      form.discountReward &&
      form.fiscalCode
    ) {
      if (!mainImage.logo) {
        setSeverity("error");
        setLogoImageError(true);
        setOpen(true);
        setErrorMsg(defaultString.validData);
        return;
      }
      const formData = new FormData();
      const user = JSON.parse(localStorage.getItem("user"));

      if (mainImage.logo != null) {
        formData.append("mainImage", mainImage.logo);
      }

      console.log(documents);
      if (documents.length > 0) {
        documents.map((image, i) => {
          if (!!image.document) formData.append("document", image.document);
        });
      }
      setIsDisabledSaveBtn(true);
      console.log(status);
      let prodStatus = status === true ? "Active" : "InActive";
      console.log(prodStatus);

      formData.append("status", prodStatus);
      formData.append("isSignin", 0);
      formData.append("firstName", form.firstName);
      formData.append("lastName", form.lastName);
      formData.append("discountReward", form.discountReward);
      formData.append("role", "Agent"); // It will be different as per user
      formData.append("email", form.email);
      formData.append("password", form.password);
      formData.append("code", code);
      formData.append("passportId", passport);
      formData.append("fiscalCode", form.fiscalCode);
      formData.append("dob", dob);
      formData.append("createdby", user._id);

      await axios
        .post(apiURL.service_create_user, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            // 'Authorization': token
          },
        })
        .then((res) => {
          console.log(res.data);
          if (res.status === apiStatusCode.CREATED) {
            setOpen(true);
            setSeverity("success");
            setErrorMsg(res.data.message);
            props.handleClose({
              reload: true,
            });
            // navigate(`/admin/users-list/agent`);
          } else {
            console.log("In else portion ", res.data);
            setOpen(true);
            setSeverity("error");
            setIsDisabledSaveBtn(false);
            setErrorMsg(res.data.message);
            props.handleClose({
              reload: true,
            });
          }
        })
        .catch((error) => {
          console.log(error.response);
          setOpen(true);
          setSeverity("error");
          setIsDisabledSaveBtn(false);
          if (error.code === defaultString.network_error)
            setErrorMsg(error.message);
          else setErrorMsg(error.response.data.message);
          if (error?.response?.status === apiStatusCode.UNAUTHORIZED) {
            doLogout(error);
          }
        });
    } else {
      setSeverity("error");
      setOpen(true);
      setErrorMsg(defaultString.validData);
    }
  };

  const fnEditUser = async (userId) => {
    // e.preventDefault();
    const token = JSON.parse(localStorage.getItem(defaultString.jsonWebToken));

    if (!mainImage.logo) {
      setLogoImageError(true);
      setSeverity("error");
      setOpen(true);
      setErrorMsg(defaultString.validData);
    }

    // if (!isValid) {
    //     setOpen(true);
    //     setErrorMsg(defaultString.validData)
    //     console.log(isValid);
    //     return
    // };
    if (
      form.email &&
      form.firstName &&
      form.lastName &&
      form.discountReward &&
      form.fiscalCode
    ) {
      if (!mainImage.logo) {
        setLogoImageError(true);
        setSeverity("error");
        setOpen(true);
        setErrorMsg(defaultString.validData);
        return;
      }
      if (documents.length > 5) {
        setSeverity("error");
        setOpen(true);
        setErrorMsg(defaultString.maxDocumentLimitMsg);
        return;
      }

      const formData = new FormData();

      if (!!mainImage.logo && mainImage.id === 0) {
        if (isChangeMainImage === true) {
          formData.append("mainImage", mainImage.logo);
        }
      }

      console.log(documents);
      if (documents.length > 0) {
        documents.map((image, i) => {
          if (!!image.document && image.id === 0)
            formData.append("document", image.document);
        });
      }

      let prodStatus = status === true ? "Active" : "InActive";
      console.log(prodStatus);
      setIsDisabledSaveBtn(true);
      formData.append("status", prodStatus);
      formData.append("userId", userId);
      formData.append("firstName", form.firstName);
      formData.append("lastName", form.lastName);
      formData.append("discountReward", form.discountReward);
      formData.append("role", "Agent"); // It will be different as per user
      formData.append("email", form.email);
      // formData.append('password', input.password)
      formData.append("code", code);
      formData.append("passportId", passport);
      formData.append("fiscalCode", form.fiscalCode);
      formData.append("dob", dob);

      await axios
        .post(apiURL.service_update_user, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        })
        .then((res) => {
          console.log(res.data);
          if (res.status === apiStatusCode.SUCCESS) {
            setOpen(true);
            setSeverity("success");
            setIsEdit(false);
            setErrorMsg(res.data.message);
            props.handleClose({ reload: true });
          } else {
            console.log("In else portion ", res.data);
            setSeverity("error");
            setOpen(true);
            setIsDisabledSaveBtn(false);
            setErrorMsg(res.data.message);
          }
        })
        .catch((error) => {
          console.log(error.response);
          setSeverity("error");
          setOpen(true);
          setIsDisabledSaveBtn(false);
          if (error.code === defaultString.network_error)
            setErrorMsg(error.message);
          else setErrorMsg(error.response.data.message);
          if (error?.response?.status === apiStatusCode.UNAUTHORIZED) {
            doLogout(error);
          }
        });
    } else {
      setSeverity("error");
      setOpen(true);
      setErrorMsg(defaultString.validData);
    }
  };

  const fnDeleteAttachment = async (attachmentId) => {
    const token = JSON.parse(localStorage.getItem(defaultString.jsonWebToken));

    await axios
      .delete(apiURL.service_delete_user_attachment + `/${attachmentId}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status === apiStatusCode.DELETED) {
          setOpen(true);
          setErrorMsg(res.data.message);
          setSeverity("success");
          if (attachType == "mainImage") {
            setMainImage({ id: 0, logo: null });
          } else if (attachType == "document") {
            const filteredArr = documents.filter(
              (item) => item.id !== attachmentId
            );
            setDocuments(filteredArr);
          }

          setAttachmentId("");
        } else {
          setOpenDeleteAlert(false);
          console.log("In else portion ", res.data);
          setSeverity("error");
          setOpen(true);
          setErrorMsg(res.data.data.message);
        }
      })
      .catch((error) => {
        console.log(error.response);
        setSeverity("error");
        setOpen(true);
        if (error.code === defaultString.network_error)
          setErrorMsg(error.message);
        else setErrorMsg(error.response.data.message);
        if (error?.response?.status === apiStatusCode.UNAUTHORIZED) {
          doLogout(error);
        }
      });
  };

  const fnDeleteProduct = async (attachmentId) => {
    const token = JSON.parse(localStorage.getItem(defaultString.jsonWebToken));
    console.log("token ", token);
    const objProduct = JSON.stringify({
      userIds: [attachmentId],
    });

    console.log(objProduct);
    setIsDisabledDeleteBtn(true);
    await axios
      .post(apiURL.service_delete_users, objProduct, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status === apiStatusCode.DELETED) {
          setOpen(true);
          setAttachmentId("");
          setSeverity("success");
          setErrorMsg(res.data.message);
          props.handleClose({
            reload: true,
          });
        } else {
          console.log("In else portion ", res.data);
          setSeverity("error");
          setOpen(true);
          setIsDisabledDeleteBtn(false);
          setErrorMsg(res.data.data.message);
        }
      })
      .catch((error) => {
        console.log(error.response);
        setOpen(true);
        setSeverity("error");
        setIsDisabledDeleteBtn(false);
        if (error.code === defaultString.network_error)
          setErrorMsg(error.message);
        else setErrorMsg(error.response.data.message);
        if (error?.response?.status === apiStatusCode.UNAUTHORIZED) {
          doLogout(error);
        }
      });
  };

  const onStatusChange = () => {
    setStatus(!status);
  };

  const doLogout = async (resErr) => {
    const data = await resetToken();
    if (data === true) {
      dispatch({ type: "LOGOUT", payload: null });
      navigate("/", {
        state: { isModalPopup: true, errorMsg: resErr.response.data.message },
      });
    }
  };

  return (
    <>
      <Modal
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "70%",
            backgroundColor: "white",
            borderRadius: 2,
            height: "80%",
          }}
        >
          <Box
            sx={{
              padding: "8px 16px",
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "white",
              borderBottom: "1px solid #d4d4d4",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: "24px",
                marginRight: "24px",
              }}
            >
              {t("add") + " " + t("agent")}
            </Typography>

            <IconButton
              onClick={() => {
                props.handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Box>

          <Container
            fluid="md"
            style={{
              height: "90%",
              overflowY: "scroll",
            }}
          >
            <Box>
              <Typography
                sx={{ fontSize: "16px", fontWeight: 700 }}
                className="my-2"
              >
                {t("status")}
              </Typography>
              <Row>
                <Col>
                  <Form>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      name="status"
                      checked={status}
                      value={status}
                      className="custom-switch-lg"
                      onChange={onStatusChange}
                    />
                  </Form>
                </Col>
              </Row>

              <Typography
                sx={{ fontSize: "16px", fontWeight: 700 }}
                className="my-2"
              >
                {t("images")}
              </Typography>
              <Row>
                <Col lg="6">
                  <Form.Group controlId="formFile1" className="mb-3">
                    <Form.Label>{t("chooseMainImage") + "*"}</Form.Label>
                    <Form.Control
                      type="file"
                      className="no-focus-shadow"
                      onChange={handleMainPicture}
                      name="mainImage"
                      accept="image/*"
                    />
                    <div className="sec-row">
                      {!!mainImage.logo && (
                        <>
                          {mainImage.id === 0 ? (
                            <img
                              key={mainImage.logo.name}
                              className="mt-3"
                              accept="image/*"
                              src={
                                mainImage.logo !== null ||
                                mainImage.logo !== undefined
                                  ? URL.createObjectURL(mainImage.logo)
                                  : null
                              }
                              alt={mainImage.logo.name}
                              height={80}
                              width={80}
                            />
                          ) : (
                            <img
                              key={mainImage.logo}
                              className="mt-3"
                              accept="image/*"
                              src={
                                mainImage.logo
                                  ? apiURL.siteBaseUrl + mainImage.logo
                                  : null
                              }
                              alt={mainImage.logo}
                              height={80}
                              width={80}
                            />
                          )}

                          <MdCancel
                            fontSize={20}
                            className="close-icon"
                            onClick={() =>
                              deleteItem(mainImage.id, 0, "mainImage")
                            }
                          />
                        </>
                      )}
                      {logoImageError ? (
                        <p className="productErrorMessage">{t("logoError")}</p>
                      ) : null}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Box
                sx={{
                  border: "1px solid #e2e2e2",
                  marginY: "16px",
                }}
              />
              <Row>
                <Typography sx={{ marginBottom: "8px", fontWeight: 700 }}>
                  {t("documents")}
                </Typography>
                <Col lg="6">
                  <Form.Group controlId="formFile2" className="mb-3">
                    <Form.Label>{t("uploadDocuments")}</Form.Label>
                    <Form.Control
                      type="file"
                      className="no-focus-shadow"
                      onChange={handleDocuments}
                      multiple
                      accept="application/pdf,.doc,.docx"
                    />
                    {documents.length > 0 &&
                      documents.map((item, index) => {
                        return (
                          !!item.document && (
                            <div key={index} className="img-list">
                              {item.id === 0 ? (
                                <h6 className="mt-1 ms-2">
                                  {item.document.name}
                                </h6>
                              ) : (
                                <h6 className="mt-1 ms-2">
                                  {item.document.split("/companyProfile/")[1]}
                                </h6>
                              )}
                              <MdCancel
                                fontSize={20}
                                className="doc-icon"
                                onClick={() =>
                                  deleteItem(item.id, index, "document")
                                }
                              />
                            </div>
                          )
                        );
                      })}
                  </Form.Group>
                </Col>
              </Row>
              <Box
                sx={{
                  border: "1px solid #e2e2e2",
                  marginY: "16px",
                }}
              />
              <Row>
                <Typography sx={{ marginBottom: "8px", fontWeight: 700 }}>
                  {t("info")}
                </Typography>
                <Col lg="6">
                  {/* <Form.Control
                            type="text"
                            className="no-focus-shadow text-capitalize"
                            placeholder={t("name")}
                          /> */}
                  <Form.Floating>
                    <Form.Control
                      type="text"
                      className="no-focus-shadow"
                      placeholder={t("firstName")}
                      value={form.firstName}
                      name="firstName"
                      onChange={onUpdateField}
                      onBlur={onBlurField}
                      required
                    />
                    <label htmlFor="floatingInputCustom">
                      {t("firstName") + "*"}
                    </label>
                  </Form.Floating>
                  {errors.firstName.dirty && errors.firstName.error ? (
                    <p className="productErrorMessage pb-0 mb-0">
                      {t("firstNameError")}
                    </p>
                  ) : null}
                </Col>
                <Col lg="6">
                  <Form.Floating>
                    <Form.Control
                      type="text"
                      className="no-focus-shadow"
                      placeholder={t("lastName")}
                      value={form.lastName}
                      name="lastName"
                      onChange={onUpdateField}
                      onBlur={onBlurField}
                      required
                    />
                    <label htmlFor="floatingInputCustom">
                      {t("lastName") + "*"}
                    </label>
                  </Form.Floating>
                  {errors.lastName.dirty && errors.lastName.error ? (
                    <p className="productErrorMessage pb-0 mb-0">
                      {t("lastNameError")}
                    </p>
                  ) : null}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col lg="4">
                  <Form.Floating>
                    <Form.Control
                      type="text"
                      className="no-focus-shadow"
                      placeholder={t("id")}
                      onChange={(e) => setPassport(e.target.value)}
                      value={passport}
                    />
                    <label htmlFor="floatingInputCustom">{t("id")}</label>
                  </Form.Floating>
                </Col>
                <Col lg="4">
                  <Form.Floating>
                    <Form.Control
                      type="text"
                      className="no-focus-shadow"
                      placeholder={t("fiscalCode")}
                      value={form.fiscalCode}
                      name="fiscalCode"
                      onChange={onUpdateField}
                      onBlur={onBlurField}
                      required
                    />
                    <label htmlFor="floatingInputCustom">
                      {t("fiscalCode") + "*"}
                    </label>
                  </Form.Floating>
                  {errors.fiscalCode.dirty && errors.fiscalCode.error ? (
                    <p className="productErrorMessage pb-0 mb-0">
                      {t("fiscalCodeError")}
                    </p>
                  ) : null}
                </Col>
                <Col lg="4">
                  <Form.Floating>
                    <Form.Control
                      type="text"
                      className="no-focus-shadow"
                      placeholder={t("discount")}
                      value={form.discountReward}
                      name="discountReward"
                      onChange={onUpdateField}
                      onBlur={onBlurField}
                      required
                    />
                    <label htmlFor="floatingInputCustom">
                      {t("discount") + "*"}
                    </label>
                  </Form.Floating>
                  {errors.discountReward.dirty &&
                  errors.discountReward.error ? (
                    <p className="productErrorMessage pb-0 mb-0">
                      {t("discountRewardError")}
                    </p>
                  ) : null}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col lg="4">
                  <Form.Floating>
                    <Form.Control
                      type="email"
                      className="no-focus-shadow"
                      placeholder={t("email")}
                      value={form.email}
                      name="email"
                      onChange={onUpdateField}
                      onBlur={onBlurField}
                      required
                    />
                    <label htmlFor="floatingInputCustom">
                      {t("email") + "*"}
                    </label>
                  </Form.Floating>

                  {errors.email.dirty && errors.email.error ? (
                    <p className="productErrorMessage pb-0 mb-0">
                      {t("emailError")}
                    </p>
                  ) : null}
                </Col>
                {!props.isEdit && (
                  <Col lg="4">
                    <InputGroup>
                      <Form.Floating>
                        <Form.Control
                          className="no-focus-shadow"
                          type={isRevealPwd ? "text" : "password"}
                          placeholder={t("password")}
                          aria-label={t("password")}
                          aria-describedby="basic-addon2"
                          name="password"
                          onChange={onUpdateField}
                          onBlur={onBlurField}
                          value={form.password}
                          required
                        />
                        <label htmlFor="floatingInputCustom">
                          {t("password") + "*"}
                        </label>
                      </Form.Floating>

                      <Button
                        variant="secondary"
                        style={{
                          backgroundColor: "#ced4da",
                          border: "1px solid #ced4da",
                        }}
                        id="button-addon2s"
                        onClick={() =>
                          setIsRevealPwd((prevState) => !prevState)
                        }
                      >
                        {isRevealPwd ? <FaEye /> : <FaEyeSlash />}
                      </Button>
                    </InputGroup>
                    {errors.password.dirty && errors.password.error ? (
                      <p className="productErrorMessage mb-0 pb-0">
                        {t("passwordError")}
                      </p>
                    ) : null}
                  </Col>
                )}

                {!props.isEdit && (
                  <Col lg="4">
                    <InputGroup>
                      <Form.Floating>
                        <Form.Control
                          type={isRevealCPwd ? "text" : "password"}
                          className="no-focus-shadow"
                          placeholder={t("cnfmPassword")}
                          aria-label={t("cnfmPassword")}
                          aria-describedby="basic-addon2"
                          name="confirmPassword"
                          onChange={onUpdateField}
                          onBlur={onBlurField}
                          value={form.confirmPassword}
                          required
                        />
                        <label htmlFor="floatingInputCustom">
                          {t("cnfmPassword") + "*"}
                        </label>
                      </Form.Floating>

                      <Button
                        variant="secondary"
                        style={{
                          backgroundColor: "#ced4da",
                          border: "1px solid #ced4da",
                        }}
                        id="button-addon2"
                        onClick={() =>
                          setIsRevealCPwd((prevState) => !prevState)
                        }
                      >
                        {isRevealCPwd ? <FaEye /> : <FaEyeSlash />}
                      </Button>
                    </InputGroup>
                    {errors.confirmPassword.dirty &&
                    errors.confirmPassword.error ? (
                      <p className="productErrorMessage mb-0 pb-0">
                        {t("confirmPasswordError")}
                      </p>
                    ) : null}
                  </Col>
                )}
              </Row>
              <Row className="mt-3">
                <Col lg="6">
                  <Form.Floating>
                    <Form.Control
                      type="date"
                      className="no-focus-shadow"
                      placeholder="DOB"
                      value={dob}
                      onChange={(e) => setDob(e.target.value)}
                    />
                    <label htmlFor="floatingInputCustom">{t("DOB")}</label>
                  </Form.Floating>
                </Col>
                <Col lg="6">
                  <Form.Floating>
                    <Form.Control
                      type="text"
                      className="no-focus-shadow"
                      placeholder={t("code")}
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                    />
                    <label htmlFor="floatingInputCustom">{t("code")}</label>
                  </Form.Floating>
                </Col>
              </Row>

              <Box
                sx={{
                  border: "1px solid #e2e2e2",
                  marginY: "16px",
                }}
              />
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "end",
                  width: "100%",
                  marginBottom: "4px",
                }}
              >
                {props.isEdit && (
                  <Grid item xs={1}>
                    <Button
                      sx={{
                        backgroundColor: "#ff6166",
                        "&:hover": {
                          backgroundColor: "#fa1919",
                        },
                      }}
                      fullWidth
                      variant="contained"
                      size="medium"
                      onClick={() =>
                        deleteItem(props.stateObj._id, 0, "product")
                      }
                    >
                      {t("delete")}
                    </Button>
                  </Grid>
                )}
                <Grid item xs={1} ml={1}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      backgroundColor: "var(--primary-color)",
                      "&:hover": {
                        backgroundColor: "var(--primary-color-hover)",
                      },
                    }}
                    size="medium"
                    onClick={
                      props.isEdit
                        ? () => fnEditUser(props.stateObj._id)
                        : fnAddUser
                    }
                  >
                    {t("save")}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Modal>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        sx={{ width: "100%" }}
      >
        <Alert onClose={handleAlertClose} severity={severity}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <AlertDialog
        open={openDeleteAlert}
        title={
          attachType === "product" ? "Delete Product" : "Delete Attachment"
        }
        message={
          attachType === "product"
            ? "Are you sure you want to delete the product?"
            : "Are you sure you want to delete the attachment?"
        }
        handleAction={confirmDeleteItem}
        handleClose={handleDeleteAlertClose}
      ></AlertDialog>
    </>
  );
};

export default AddAgent;
